// Pont entre les CustomEvent internes "hexagon:*" (deja dispatches un peu
// partout dans le theme pour la coordination UI — voir assets/cart.js,
// configurateur.js, faq-browser.js, rmt-form.js, rmt-simulateur.js,
// rmt-tracking.js) et les Web Pixels Shopify (Admin > Reglages > Evenements
// client). `Shopify.analytics.publish(name, data)` est le seul mecanisme
// documente pour qu'un theme emette un evenement custom que peut recevoir
// un pixel personnalise via `analytics.subscribe(name, callback)` — voir
// https://shopify.dev/docs/api/web-pixels-api/emitting-data. Shopify exige
// un nom prefixe pour eviter les collisions ; les evenements internes sont
// deja tous nommes "hexagon:xxx", reutilises tels quels ici.
//
// Charge globalement dans layout/theme.liquid (comme reveal.js/header.js)
// pour etre pret avant tout script de section qui l'utilise (les scripts
// `defer` s'executent dans l'ordre du document, jamais avant).
window.HexagonAnalytics = {
  publish: function (name, detail) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, detail || {});
      }
      // Relais GA4 via le module commun (assets/hexagon-tracking.js) : meme identifiant visiteur, memes regles
      // de consentement. Remplace le pixel personnalise Shopify « Hexagon — Evenements custom ».
      if (window.HexagonTracking && typeof window.HexagonTracking.legacy === 'function') window.HexagonTracking.legacy(name, detail);
    } catch (e) {
      // Ne jamais casser l'UI si Shopify.analytics n'est pas disponible/pret
      // (ex. Web Pixels desactives, contexte de preview...).
    }
  }
};
